<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/DateTime/NewDDateTimePreview'
export default {
  name: 'NewDReleaseTimePreview',
  extends: compoment
}
</script>
